import { render, staticRenderFns } from "./sponsorsEdition.vue?vue&type=template&id=e9089ade"
import script from "./sponsorsEdition.vue?vue&type=script&lang=js"
export * from "./sponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports